import { APP_ENV } from '@/common/api';

/** 门店AI营销页面地址 */
const STORE_MARKETING_ENDPOINTS = {
  prod: 'https://marketing.th.maxiot.com/',
  test: 'http://marketing.test.maxiot.com/',
} as const;

/**
 * 跟随 APP_ENV：token 由 API 环境签发，
 * 把 prod token 传给 test 营销页（或反之）会鉴权失败。
 *
 * 注意 test 环境是 http：若 Macaw 自身以 https 部署，该 iframe 属于
 * active mixed content，会被浏览器直接拦截。prod 是 https，无此问题。
 */
// export const STORE_MARKETING_URL =
// APP_ENV === 'prod' ? STORE_MARKETING_ENDPOINTS.prod : STORE_MARKETING_ENDPOINTS.test;
export const STORE_MARKETING_URL = STORE_MARKETING_ENDPOINTS.prod;

/** 本地联调：营销应用自己跑起来的地址（vite 默认端口） */
const STORE_MARKETING_DEV_URL = 'http://localhost:5173/';

/** 宿主 → 营销页：下发上下文 */
export const MAGIC_HOST_CONTEXT = 'MAGIC_HOST_CONTEXT' as const;

/** 营销页 → 宿主：已就绪，可以接收上下文 */
export const MAGIC_READY = 'MAGIC_READY' as const;

/**
 * 解析 iframe 地址。生产构建恒为 STORE_MARKETING_URL；开发构建下：
 *
 * 1. `?marketingUrl=...` 显式覆盖优先（指向本地 stub 或真实环境时用）
 * 2. 否则默认指向本地跑起来的营销应用 http://localhost:5173/
 *
 * targetOrigin 由这里返回的地址推导，覆盖地址会同步改掉 targetOrigin，
 * 两者始终一致，消息不会因 origin 不匹配被静默丢弃。
 *
 * 生产构建下 process.env.NODE_ENV 被替换为字面量 'production'，
 * 整段覆盖逻辑会被 Terser 剔除。
 */
export function resolveStoreMarketingUrl(): string {
  if (process.env.NODE_ENV === 'production') return STORE_MARKETING_URL;
  if (typeof window === 'undefined') return STORE_MARKETING_URL;

  const override = new URLSearchParams(window.location.search).get('marketingUrl');
  if (override && override.trim()) return override.trim();

  // 开发构建默认打本地营销应用；要打真实环境用 ?marketingUrl= 显式指定
  return STORE_MARKETING_DEV_URL;
}
